import React from "react";
import { engagements } from "../data/engagements";
export function Engagements() {
  return <section aria-labelledby="engagements-title" className="bg-paper py-20 md:py-28" data-id="element-47" data-mp="1vrw7j2wkug4m">
      <div className="mx-auto grid max-w-site gap-14 px-5 md:px-8 lg:grid-cols-12 lg:gap-16" data-id="element-48" data-mp="1qt3463b085i6">
        <div className="lg:col-span-6" data-id="element-49" data-mp="1lui4c4znznu9">
          <h2 id="engagements-title" className="font-display text-3xl font-medium leading-tight text-ink md:text-[2.75rem] md:leading-[1.1]" data-id="element-50" data-mp="1lvkta7dffg7j">
            MANY Loisirs aménage votre véhicule, avec un seul objectif : allier confort et plaisir.
          </h2>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-muted" data-id="element-51" data-mp="29jkj952wz2l2">
            Découvrez nos gammes d'aménagements complètes et nos spécialités pour personnaliser votre espace de vie nomade. Des équipements de qualité pour concrétiser vos rêves d'évasion.
          </p>
        </div>

        <ul className="grid gap-x-10 sm:grid-cols-2 lg:col-span-6" data-id="element-52" data-mp="t5klo0rjjp0z">
          {engagements.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="border-t border-line py-7" data-id="element-53" data-mp="25cggvpx7q1g4">
              <Icon className="h-6 w-6 text-clay" strokeWidth={1.75} aria-hidden="true" data-id="element-54" data-mp="2absztzkyqodf" />
              <h3 className="mt-4 text-base font-semibold text-ink" data-id="element-55" data-mp="2a9gmjzq5h26p">{title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-56" data-mp="1veacn1nxoj83">{text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}